import { Backdrop, Box } from "@mui/material";
import LoadingIndicator from "@/shared/ui/LoadingIndicator";
import { useAppSelector } from "@/app/hooks";
import { CHAIN } from "@/config/config";
import { ChainType } from "@/constants/enum/enum";
import { useEffect, useState } from "react";
import { selectXPMarket } from "@/features/xp-market";
import { selectIsRaceBusy } from "@/features/race";
import { selectWeeklyMissions } from "@/features/story";
import { selectIsClaimingMysteryBox } from "@/features/mystery-box";
import { selectIsTrainingKill } from "@/features/kill-skill";
import { selectIsMakingCrime } from "@/features/crime";
import { selectIsNickingCar } from "@/features/nick-car";
import { selectIsGarageBusy } from "@/features/garage";
import {
  selectIsBuyingOut,
  selectIsBustingOut,
} from "@/features/jail";
const BackOverlay = () => {
  const {
    isSigningData,
    isLoadingFamilyDetail,
    isUpdatingLeader,
    isAcceptingInvitation,
    isRejectingInvitation,
    isCancelingInvitation,
    isLeavingFamily,
    isKickingMember,
    isUpdatingFamilyBranding,
    isUpdatingFamilyPromotion,
    isUpdatingFamilyLeaveFee,
    isWithdrawingStaking,
    isDepositingFamilyGameCash,
    isWithdrawingFamilyGameCash,
    isWithdrawingFamilyNative,
    isSwappingFamilyNative,
  } = useAppSelector((state) => state.family);

  const {
    isBuyingCrate,
    isOpeningCrate,
    isRequestOpenCrate,
    isFinishOpenCrate,
    isWaitingVRF,
  } = useAppSelector((state) => state.crate);

  const {
    isTransferringItem,
    isTransferringCrate,
    isWrappingOgCrate,
    isUnwrappingOgCrate,
    isWrappingOGNFTAction,
    isUnwrappingOGNFTAction,
    isUnwrappingKeyItem,
    isUnwrappingMafiaItem,
    isUnwrappingOGNFTItem,
    isUnwrappingBulletItem,
    isUnwrappingHealth,
    isUnwrappingHelperCreditsItem,
    isUnwrappingGICreditsItems,
    isUnwrappingFounderTableShareItems,
    isApprovingCrate,
    isApprovingOGNFT,
  } = useAppSelector((state) => state.inventory);

  const {

    isSigningProfileData,
    isUpdatingProfileDescription,

    isCreatingProfile,
    isUpdatingAvatar,
    isUpdatingBackground,
  } = useAppSelector((state) => state.profile);
  const { isBuyingHelperCredit } = useAppSelector((state) => state.helperBot);
  const { isBuyingLegacyPremium, isClaimingKeys } = useAppSelector(
    (state) => state.premium
  );
  const isLoadingCashHistory = useAppSelector(
    (state) => state.cashHistory.isLoading
  );
  const isLoadingCreditHistory = useAppSelector(
    (state) => state.creditHistory.isLoading
  );

  const {
    isCreatingListing,
    isPurchasingFixedItem,
    isBidOnAuctionItem,
    isCancelListing,
    isFinishAuctionItem,
  } = useAppSelector((state) => state.market);

  const {
    isConvertingItems,
    isCreatingOTC,
    isAcceptingOTC,
    isCancelingOTC,
    isAddLiquidity,
    isLoadingAvgCashPerMafia,
    isDepositApprove,
    loadingWithdrawStat,
    isCancelLiquidity,
    isSwapping,
    isExecutingSwap,
  } = useAppSelector((state) => state.exchange);

  const { isLoadingWorldMapInfo } = useAppSelector((state) => state.map);

  const {
    isCreatingProposal,
    isGettingProposals,
    isOpeningProposal,
    isVotingProposal,
    isClosingProposal,
    isWithdrawingProposal,
  } = useAppSelector((state) => state.dao);

  const {
    isRouletteListLoading,
    isInitializingBet,
    isFinishingBet,
    isUpdatingRouletteSettings,
    isAddingLiquidity,
    isRemovingLiquidity,
    isApprovingGameCash,
  } = useAppSelector((state) => state.roulette);

  const {
    isSlotMachineListLoading,
    isAddingLiquidity: isSlotMachineAddingLiquidity,
    isApprovingGameCash: isSlotMachineApprovingGameCash,
    isFinishingBet: isSlotMachineFinishingBet,
    isInitializingBet: isSlotMachineInitializingBet,
    isGettingSlotMachineLiquidity: isSlotMachineGettingSlotMachineLiquidity,
    isRemovingLiquidity: isSlotMachineRemovingLiquidity,
    isUpdatingSlotMachineSettings: isSlotMachineUpdatingSlotMachineSettings,
    isVrfPending,
  } = useAppSelector((state) => state.slot);

  const { isLoadingBusinessList, loadingBusinessProfile } = useAppSelector(
    (state) => state.business
  );

  const { isDividingHealthItems } = useAppSelector((state) => state.inventory);
  const { isBuyingGICredit, isCreatingGIRequest } = useAppSelector(
    (state) => state.gameIntelligence
  );

  const { isEnteringLotteryHall, isFinishingLotteryHallRound, isLotteryHallOwnerWithdrawing } =
    useAppSelector((state) => state.lotteryHall);

  const {
    isApprovingGameCash: isApprovingGame,
    isTransferringGameCash,
    isSettingCityOwnerFee,
  } = useAppSelector((state) => state.bank);

  const { isLoadingHelperBotInfo, isStartingHelperBot, isEndingHelperBot, isApprovingHelperCredit } = useAppSelector(
    (state) => state.helperBot
  );

  const {
    isApprovingBullet,
    isApprovingBulletToken,
    isBuyingBullet,
    isDepositingBulletToken,
    isProducingBullet,
    isWithdrawingBullet,
  } = useAppSelector(
    (state) => state.bulletFactory
  );
  const { isTraveling } = useAppSelector((state) => state.travel);

  const {
    isClaimingSmugglingProfit,
    isSellingWrappedBooze,
    isSellingWrappedNarcs,
    isSmuggling,
  } = useAppSelector(
    (state) => state.smuggling
  );

  const { isListXP, isLoadingXPMarketList, isXpMarketAction } =
    useAppSelector(selectXPMarket);

  const isRaceBusy = useAppSelector(selectIsRaceBusy);
  const { isStartingWeeklyMission } = useAppSelector(selectWeeklyMissions);
  const isClaimingMysteryBox = useAppSelector(selectIsClaimingMysteryBox);
  const isTrainingKill = useAppSelector(selectIsTrainingKill);
  const isMakingCrime = useAppSelector(selectIsMakingCrime);
  const isNickingCar = useAppSelector(selectIsNickingCar);
  const isBuyingOut = useAppSelector(selectIsBuyingOut);
  const isBustingOut = useAppSelector(selectIsBustingOut);
  const isLoadingCarAction = useAppSelector(selectIsGarageBusy);

  const {
    isClaimingPerkBox,
    isBuyingPerkBox,
    isFinishOpenPerkBox,
    isRequestOpenPerkBox,
    isActivatingPerk,
    isCancellingPerk,
  } = useAppSelector((state) => state.perk);

  const {
    isGettingBetLimits,
    isGettingTotalAccumulatedFees,
    isGettingCurrentRoundTotalPotUSD,
    isGettingCurrentRoundFeeAmount,
    isGettingCurrentRoundPerkBoxItemIds,
    isGettingCurrentRound,
    isGettingRoundAmounts,
    isGettingAssetsPrice,
    isEnteringPot,
    isEnteringPotWithPerkBoxes,
    isCalculatingWinner,
    isEnteringPotWithInventoryItem,
  } = useAppSelector((state) => state.jackpot);

  const { isLoadingChartData } = useAppSelector((state) => state.metrics);

  const { loading } = useAppSelector((state) => state.inbox);

  const { isGettingCityShopInfo, isBuyingItems, isUpdatingCityCostPrice } = useAppSelector(
    (state) => state.shop
  );

  const { isAuthorizing } = useAppSelector((state) => state.auth);

  const { isEquippingItems, isGettingItemsInfo } = useAppSelector((state) => state.equipment);

  const { isSubcribing } = useAppSelector((state) => state.premium);

  const { isRebirthing } = useAppSelector((state) => state.rebirth);

  const {
    isCreatingLobby,
    isJoiningDriver,
    isJoiningWeaponExpert,
    isJoiningExplosiveExpert,
    isJoiningTeamExpert,
    isKickingMember: isKickingMemberOrganizedCrime,
    isLeavingLobby: isLeavingLobbyOrganizedCrime,
    isCancelingLobby: isCancelingLobbyOrganizedCrime,
    isStartingLobby,
    isFinishingLobby,
    isClaimingReward,
  } = useAppSelector((state) => state.organizedCrime);

  const {
    isClaimingProfit: isClaimingCrusherProfit,
    isUpdatingSettings: isUpdatingCrusherSettings,
    isCrushingCars,
    isApprovingGameCash: isApprovingCrusherGameCash,
  } = useAppSelector((state) => state.carCrusher);

  const { isEnteringSafehouse, isExitingSafehouse } = useAppSelector(
    (state) => state.safehouse
  );

  const {
    isRequestingHire,
    isFinishingHire,
    isRevealingTarget,
    isApprovingGameCash: isApprovingDetectiveGameCash,
    isClaimingProfit,
    isSettingCost,
  } = useAppSelector((state) => state.detective);

  const [loadingText, setLoadingText] = useState("");

  useEffect(() => {
    if (!isSwapping) {
      setLoadingText("");
      return;
    }
    setLoadingText("Matching your order with liquidity");

    let timeout = setTimeout(() => {
      setLoadingText("Purchasing cash liquidity");
    }, 12000);

    return () => {
      clearTimeout(timeout);
    };
  }, [isSwapping]);

  return (
    <Backdrop
      sx={{
        color: (theme) => theme.design.color.text.primary,
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
      open={
        isLoadingFamilyDetail ||
        isSigningData ||
        isUpdatingLeader ||
        isAcceptingInvitation ||
        isRejectingInvitation ||
        isCancelingInvitation ||
        isLeavingFamily ||
        isKickingMember ||
        isUpdatingFamilyBranding ||
        isUpdatingFamilyPromotion ||
        isUpdatingFamilyLeaveFee ||
        isBuyingCrate ||
        isApprovingCrate ||
        isRequestOpenCrate ||
        isFinishOpenCrate ||
        isAcceptingInvitation ||
        isWaitingVRF ||
        isTransferringItem ||
        isTransferringCrate ||
        isOpeningCrate ||
        isCreatingListing ||
        isPurchasingFixedItem ||
        isBidOnAuctionItem ||
        isCancelListing ||
        isFinishAuctionItem ||
        isWrappingOgCrate ||
        isUnwrappingOgCrate ||
        isWrappingOGNFTAction ||
        isUnwrappingOGNFTAction ||
        isUnwrappingKeyItem ||
        isApprovingOGNFT ||
        isApprovingCrate ||
        isUnwrappingMafiaItem ||
        isUnwrappingOGNFTItem ||
        isUnwrappingFounderTableShareItems ||
        isBuyingLegacyPremium ||
        isSigningData ||
        isSigningProfileData ||
        isUpdatingProfileDescription ||
        isClaimingKeys ||
        isConvertingItems ||
        isCreatingOTC ||
        isAcceptingOTC ||
        isCancelingOTC ||
        isWithdrawingStaking ||
        isDepositingFamilyGameCash ||
        isWithdrawingFamilyGameCash ||
        isWithdrawingFamilyNative ||
        isSwappingFamilyNative ||
        isAddLiquidity ||
        isLoadingAvgCashPerMafia ||
        isDepositApprove ||
        loadingWithdrawStat ||
        isCancelLiquidity ||
        isSwapping ||
        isExecutingSwap ||
        isLoadingWorldMapInfo ||
        isLoadingCreditHistory ||
        isLoadingCashHistory ||
        isCreatingProposal ||
        isGettingProposals ||
        isOpeningProposal ||
        isVotingProposal ||
        isClosingProposal ||
        isWithdrawingProposal ||
        isRouletteListLoading ||
        isInitializingBet ||
        isFinishingBet ||
        isUpdatingRouletteSettings ||
        isAddingLiquidity ||
        isRemovingLiquidity ||
        isApprovingGameCash ||
        isLoadingBusinessList ||
        loadingBusinessProfile ||
        isSlotMachineListLoading ||
        isSlotMachineAddingLiquidity ||
        isSlotMachineApprovingGameCash ||
        isSlotMachineFinishingBet ||
        isSlotMachineInitializingBet ||
        isSlotMachineGettingSlotMachineLiquidity ||
        isSlotMachineRemovingLiquidity ||
        isSlotMachineUpdatingSlotMachineSettings ||
        isVrfPending ||
        isCreatingProfile ||
        isTraveling ||
        isMakingCrime ||
        isBuyingOut ||
        isBustingOut ||
        isApprovingGame ||
        isSmuggling ||
        isNickingCar ||
        isLoadingCarAction ||
        isTrainingKill ||
        isUnwrappingHelperCreditsItem ||
        isBuyingHelperCredit ||
        isLoadingHelperBotInfo ||
        isStartingHelperBot ||
        isEndingHelperBot ||
        isApprovingHelperCredit ||
        isClaimingSmugglingProfit ||
        isBuyingBullet ||
        isUnwrappingBulletItem ||
        isUnwrappingHealth ||
        isProducingBullet ||
        isTransferringGameCash ||
        isSettingCityOwnerFee ||
        isDividingHealthItems ||
        isListXP ||
        isLoadingXPMarketList ||
        isXpMarketAction ||
        isRaceBusy ||
        isClaimingPerkBox ||
        isBuyingPerkBox ||
        isFinishOpenPerkBox ||
        isRequestOpenPerkBox ||
        isActivatingPerk ||
        isCancellingPerk ||
        isGettingBetLimits ||
        isGettingTotalAccumulatedFees ||
        isGettingCurrentRoundTotalPotUSD ||
        isGettingCurrentRoundFeeAmount ||
        isGettingCurrentRoundPerkBoxItemIds ||
        isGettingCurrentRound ||
        isGettingRoundAmounts ||
        isGettingAssetsPrice ||
        isEnteringPot ||
        isEnteringPotWithPerkBoxes ||
        isCalculatingWinner ||
        isGettingCityShopInfo ||
        isBuyingItems ||
        isUpdatingCityCostPrice ||
        isEnteringPotWithInventoryItem ||
        loading.delete ||
        isAuthorizing ||
        isEquippingItems ||
        isLoadingChartData ||
        isGettingItemsInfo ||
        isSubcribing ||
        isRebirthing ||
        isUpdatingAvatar ||
        isUpdatingBackground ||
        isBuyingGICredit ||
        isCreatingGIRequest ||
        isUnwrappingGICreditsItems ||
        isSellingWrappedBooze ||
        isSellingWrappedNarcs ||
        isStartingWeeklyMission ||
        isClaimingMysteryBox ||
        isEnteringLotteryHall ||
        isFinishingLotteryHallRound ||
        isLotteryHallOwnerWithdrawing ||
        isCreatingLobby ||
        isJoiningDriver ||
        isJoiningWeaponExpert ||
        isJoiningExplosiveExpert ||
        isJoiningTeamExpert ||
        isKickingMemberOrganizedCrime ||
        isLeavingLobbyOrganizedCrime ||
        isCancelingLobbyOrganizedCrime ||
        isStartingLobby ||
        isFinishingLobby ||
        isClaimingReward ||
        isApprovingBullet ||
        isApprovingBulletToken ||
        isDepositingBulletToken ||
        isWithdrawingBullet ||
        isRequestingHire ||
        isFinishingHire ||
        isRevealingTarget ||
        isApprovingDetectiveGameCash ||
        isClaimingProfit ||
        isSettingCost ||
        isClaimingCrusherProfit ||
        isUpdatingCrusherSettings ||
        isCrushingCars ||
        isApprovingCrusherGameCash ||
        isEnteringSafehouse ||
        isExitingSafehouse
      }
    >
      <LoadingIndicator color="inherit" size="large" label="Processing transaction" />

      {isWaitingVRF &&
        (CHAIN === ChainType.BNB ? (
          <Box>Waiting for chainlink...</Box>
        ) : (
          <Box>Waiting for block...</Box>
        ))}
      {isSwapping && <Box>{loadingText}</Box>}

      {isLoadingWorldMapInfo && <Box>Loading world map...</Box>}

      {isUpdatingCityCostPrice && <Box>Updating shop prices...</Box>}

      {isSettingCityOwnerFee && <Box>Setting bank transfer fee...</Box>}

      {(isApprovingGameCash || isSlotMachineApprovingGameCash || isApprovingGame) && (
        <Box>Approving Game Cash...</Box>
      )}

      {(isInitializingBet || isSlotMachineInitializingBet) && (
        <Box>Initializing bet...</Box>
      )}

      {(isFinishingBet || isSlotMachineFinishingBet) && (
        <Box>Finishing bet...</Box>
      )}

      {(isUpdatingRouletteSettings ||
        isSlotMachineUpdatingSlotMachineSettings) && (
          <Box>Updating settings...</Box>
        )}

      {(isAddingLiquidity || isSlotMachineRemovingLiquidity) && (
        <Box>Adding liquidity...</Box>
      )}

      {(isRemovingLiquidity || isSlotMachineRemovingLiquidity) && (
        <Box>Removing liquidity...</Box>
      )}

      {(isUpdatingAvatar || isUpdatingBackground) && (
        <Box>Updating profile...</Box>
      )}

      {isRebirthing && <Box>Rebirthing...</Box>}

      {isStartingWeeklyMission && (
        <Box>Starting weekly mission...</Box>
      )}

      {isClaimingMysteryBox && (
        <Box>Claiming mystery box...</Box>
      )}

      {isCreatingLobby && (
        <Box>Creating organized crime lobby...</Box>
      )}

      {isJoiningDriver && (
        <Box>Joining as driver...</Box>
      )}

      {isJoiningWeaponExpert && (
        <Box>Joining as weapon expert...</Box>
      )}

      {isJoiningExplosiveExpert && (
        <Box>Joining as explosive expert...</Box>
      )}

      {isJoiningTeamExpert && (
        <Box>Joining as team expert...</Box>
      )}

      {isKickingMemberOrganizedCrime && (
        <Box>Kicking member...</Box>
      )}

      {isLeavingLobbyOrganizedCrime && (
        <Box>Leaving lobby...</Box>
      )}

      {isCancelingLobbyOrganizedCrime && (
        <Box>Canceling lobby...</Box>
      )}

      {isStartingLobby && (
        <Box>Starting organized crime...</Box>
      )}

      {isFinishingLobby && (
        <Box>Finishing organized crime...</Box>
      )}

      {isClaimingReward && (
        <Box>Claiming reward...</Box>
      )}

      {isApprovingBullet && (
        <Box>Approving bullet...</Box>
      )}

      {isApprovingBulletToken && (
        <Box>Approving bullet token...</Box>
      )}

      {isDepositingBulletToken && (
        <Box>Depositing bullets...</Box>
      )}

      {isWithdrawingBullet && (
        <Box>Withdrawing bullets...</Box>
      )}

      {isApprovingDetectiveGameCash && (
        <Box>Approving game cash for detective agency...</Box>
      )}

      {isRequestingHire && (
        <Box>Requesting detective hire...</Box>
      )}

      {isFinishingHire && (
        <Box>Finishing detective hire...</Box>
      )}

      {isRevealingTarget && (
        <Box>Revealing target...</Box>
      )}

      {isClaimingProfit && (
        <Box>Claiming profit...</Box>
      )}

      {isSettingCost && (
        <Box>Setting detective cost...</Box>
      )}

      {isClaimingCrusherProfit && (
        <Box>Claiming car crusher profit...</Box>
      )}

      {isUpdatingCrusherSettings && (
        <Box>Updating car crusher settings...</Box>
      )}

      {isApprovingCrusherGameCash && (
        <Box>Approving game cash for car crusher...</Box>
      )}

      {isCrushingCars && (
        <Box>Crushing cars...</Box>
      )}

      {isEnteringSafehouse && (
        <Box>Entering safehouse...</Box>
      )}

      {isExitingSafehouse && (
        <Box>Exiting safehouse...</Box>
      )}

      {isEnteringLotteryHall && <Box>Entering Lottery Hall...</Box>}

      {isFinishingLotteryHallRound && <Box>Drawing winner...</Box>}

      {isLotteryHallOwnerWithdrawing && <Box>Stealing lottery cash...</Box>}

      {isVrfPending &&
        (CHAIN === ChainType.BNB ? (
          <Box>Waiting for chainlink...</Box>
        ) : (
          <Box>Waiting for block...</Box>
        ))}
    </Backdrop>
  );
};

export default BackOverlay;
